import React from 'react';
import Wallet from './Wallet';
import SendMessageForm from './SendMessageForm';
import AddNote from './AddNote';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import Fleets from './Fleets/Fleets';

const useStyles = makeStyles((theme) => ({
  divider: {
    margin: theme.spacing(1, 0),
  },
}));

function DriverFormCard(props) {
  const classes = useStyles();
  return (
    <>
      <Wallet />
      <Divider className={classes.divider} />
      <SendMessageForm />
      <Divider className={classes.divider} />
      <AddNote />
      <Divider className={classes.divider} />
      <Fleets />
    </>
  );
}

export default React.memo(DriverFormCard);
